/* ============================================================
   MOBILE APP LAYER
   Alt sekme çubuğu, sabit satın alma çubuğu, gizlenen başlık,
   sepet çekmecesinde sürükle-kapat.

   Kural: theme.js'in mantığını kopyalamaz. Sepet/menü/arama için
   başlıktaki mevcut düğmelere tıklama gönderir, ürünü sepete
   eklerken gerçek formun butonunu tetikler. Böylece tek bir
   doğruluk kaynağı kalır ve theme.js güncellenirse bu katman
   kendiliğinden uyumlu kalır.
============================================================ */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var mq = window.matchMedia(MOBILE);
  var cfg = (window.theme && window.theme.mobileApp) || {};

  function $(s, c) { return (c || document).querySelector(s); }
  var body = document.body;

  /* Masaüstünde hiçbir şey çalışmasın; ekran döndürülürse yeniden değerlendir */
  function isMobile() { return mq.matches; }

  /* ---------------- 1. Sekme çubuğu ---------------- */
  var tabbar = $('#mobile-tabbar');

  if (tabbar) {
    tabbar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mapp-open]');
      if (!btn) return;
      e.preventDefault();
      var target = btn.getAttribute('data-mapp-open');
      var trigger =
        target === 'cart' ? $('#cart-toggle') :
        target === 'search' ? $('#search-toggle') :
        target === 'menu' ? $('#burger') : null;

      /* Başlık gizlenmişse geri getir; menü/arama oradan açılıyor */
      body.classList.remove('mapp-header-hidden');
      if (trigger) trigger.click();
      else if (target === 'cart') window.location.href = (window.theme.routes || {}).cart_url || '/cart';
      buzz(8);
    });

    /* Koleksiyon/arama sayfalarında "Menu" sekmesi etkin görünsün */
    var pt = (body.className.match(/template-([a-z0-9-]+)/) || [])[1] || '';
    if (/^(collection|list-collections|search|product)/.test(pt)) {
      var menuTab = tabbar.querySelector('[data-mapp-open="menu"]');
      if (menuTab && /^(collection|list-collections)/.test(pt)) menuTab.classList.add('is-active');
    }

    body.classList.add('mapp-on');
  }

  /* Çekmece/overlay açıkken çubukları gizle.
     theme.js açılışta body.style.overflow'u 'hidden' yapıyor;
     bunu izlemek ayrı bir olay sistemine gerek bırakmıyor. */
  new MutationObserver(function () {
    var open = body.style.overflow === 'hidden' ||
               !!document.querySelector('.search-overlay.is-open, .facets.is-open, .product-lightbox.is-open');
    body.classList.toggle('mapp-drawer-open', open);
  }).observe(body, { attributes: true, attributeFilter: ['style', 'class'] });

  document.addEventListener('click', function () {
    /* Arama/filtre overlay'i body.overflow değiştirmiyor olabilir */
    requestAnimationFrame(function () {
      var open = body.style.overflow === 'hidden' ||
                 !!document.querySelector('.search-overlay.is-open, .facets.is-open, .product-lightbox.is-open');
      body.classList.toggle('mapp-drawer-open', open);
    });
  }, true);

  /* ---------------- 2. Kaydırınca gizlenen başlık ---------------- */
  (function stickyHeader() {
    var last = window.scrollY;
    var lastRun = 0;
    var THRESHOLD = 6;   /* bu kadar piksel oynamadan karar verme */
    var INTERVAL = 80;   /* ms — kaydırma sırasında en fazla bu sıklıkta çalışır */

    /* Zaman damgasıyla kısılıyor; requestAnimationFrame yerine bunu
       kullanmak arka plandaki sekmelerde de tutarlı davranmasını sağlar. */
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - lastRun < INTERVAL) return;
      lastRun = now;

      if (!isMobile() || body.classList.contains('mapp-drawer-open')) {
        body.classList.remove('mapp-header-hidden');
        last = window.scrollY;
        return;
      }
      var y = window.scrollY;
      var delta = y - last;
      if (Math.abs(delta) < THRESHOLD) return;
      /* Sayfa başındayken başlık her zaman görünür kalsın */
      if (y < 90) body.classList.remove('mapp-header-hidden');
      else body.classList.toggle('mapp-header-hidden', delta > 0);
      last = y;
    }, { passive: true });
  })();

  /* ---------------- 3. Ürün sayfası sabit satın alma çubuğu ---------------- */
  (function buyBar() {
    if (cfg.buyBar === false) return;
    if (!/template-product/.test(body.className)) return;

    var form = $('[data-product-form]');
    var realBtn = form && form.querySelector('[data-add-btn]');
    var priceEl = $('[data-product-price]');
    var titleEl = $('.product__title');
    if (!form || !realBtn) return;

    var bar = document.createElement('div');
    bar.className = 'mapp-buybar';
    bar.innerHTML =
      '<div class="mapp-buybar__info">' +
        '<div class="mapp-buybar__title"></div>' +
        '<div class="mapp-buybar__price"></div>' +
      '</div>' +
      '<button type="button" class="mapp-buybar__btn"></button>';
    document.body.appendChild(bar);

    var barTitle = bar.querySelector('.mapp-buybar__title');
    var barPrice = bar.querySelector('.mapp-buybar__price');
    var barBtn = bar.querySelector('.mapp-buybar__btn');

    if (titleEl) barTitle.textContent = titleEl.textContent.trim();

    /* Fiyat ve buton metni gerçek öğelerden aynalanır; varyant
       değişince theme.js onları güncelliyor, biz sadece izliyoruz. */
    function sync() {
      if (priceEl) barPrice.innerHTML = priceEl.innerHTML;
      barBtn.textContent = realBtn.textContent.trim();
      barBtn.disabled = realBtn.disabled;
    }
    sync();
    new MutationObserver(sync).observe(form, { subtree: true, childList: true, characterData: true, attributes: true });
    if (priceEl) new MutationObserver(sync).observe(priceEl, { subtree: true, childList: true, characterData: true });

    barBtn.addEventListener('click', function () {
      buzz(12);
      realBtn.click();
    });

    /* Gerçek buton ekrandan çıkınca çubuk belirsin.
       Kaydırma dinleyicisi 80 ms'de bir kısılıyor; tek bir
       getBoundingClientRect çağrısı bu sıklıkta ölçülebilir bir
       maliyet getirmiyor. */
    var lastRun = 0;
    function update() {
      var now = Date.now();
      if (now - lastRun < 80) return;
      lastRun = now;
      if (!isMobile()) { bar.classList.remove('is-visible'); return; }
      var r = realBtn.getBoundingClientRect();
      var onScreen = r.bottom > 0 && r.top < (window.innerHeight - 40);
      bar.classList.toggle('is-visible', !onScreen);
    }
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  })();

  /* ---------------- 4. Sepet çekmecesi: sürükleyerek kapat ---------------- */
  (function dragToClose() {
    var drawer = $('#cart-drawer');
    var head = drawer && drawer.querySelector('.cart-drawer__head');
    if (!drawer || !head) return;

    var startY = 0, delta = 0, dragging = false;

    head.addEventListener('touchstart', function (e) {
      if (!isMobile()) return;
      dragging = true; delta = 0;
      startY = e.touches[0].clientY;
      drawer.classList.add('is-dragging');
    }, { passive: true });

    head.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      delta = e.touches[0].clientY - startY;
      if (delta < 0) delta = 0;
      drawer.style.transform = 'translateY(' + delta + 'px)';
    }, { passive: true });

    head.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      drawer.classList.remove('is-dragging');
      drawer.style.transform = '';
      /* Yeterince aşağı çekildiyse tema kendi kapatma akışını yürütsün */
      if (delta > 90) {
        var close = drawer.querySelector('[data-close-drawer]');
        if (close) close.click();
      }
    });
  })();

  /* ---------------- 5. Dokunsal geri bildirim ---------------- */
  function buzz(ms) {
    if (cfg.haptics === false) return;
    if (navigator.vibrate) { try { navigator.vibrate(ms); } catch (e) {} }
  }

  /* Sepete eklendiğinde de kısa bir titreşim */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-add-btn]')) buzz(12);
  }, true);

})();
